module.exports = __webpack_public_path__ + "img/head.11ae158f.png";